import developmentPools from './development';
import productionPools from './production';
import { PRODUCTION } from '@/utils/constants';

const pools = process.env.NODE_ENV == PRODUCTION ? productionPools : developmentPools;

export default pools;
